import React from 'react';
import { AudioElement } from '../menus/AudioElement';
import { Marker } from '../menus/Marker';
import audioEditorUtils from '../utils/AudioEditorUtils';
import properties from '../../../constants/Properties';
import { connect } from 'react-redux';
import audioToolUtils from '../../audioTool/utils/AudioToolUtils';
import playController from '../../utils/PlayController';
import { getTouchPosition } from '../../utils/TransformToolUtils';
import timelineDragManager from '../utils/TimelineDragManager';

const AudioEditorTimelineContent = React.createClass({
    getInitialState() {
        return {
            startPoint: undefined,
            endPoint: undefined
        };
    },
    onStart(e) {
        if (e.target.id == 'timeline' || e.target.parentNode.id == 'timeline' || e.target.parentNode.parentNode.id == 'timeline') {
            if (playController.startScroll)
                playController.startScroll(e);
        }
    },
    onMove(e) {
        if (e.target.id == 'timeline' || e.target.parentNode.id == 'timeline' || e.target.parentNode.parentNode.id == 'timeline') {
            if (playController.moveScroll)
                playController.moveScroll(e);
        }
    },
    onEnd() {
        if (playController.endScroll)
            playController.endScroll();
    },
    onStartSelection(e) {
        if (!(e.target && e.target.parentNode && e.target.parentNode.parentNode && e.target.parentNode.parentNode.id == 'timeline'))
            return;

        var globalPoint = this.getGlobalPoint();
        var touchPoint = getTouchPosition(e);
        var scrollPos = playController.getScrollPosition();
        var point = {};
        point.x = touchPoint.x - globalPoint.left + scrollPos;
        point.y = touchPoint.y - globalPoint.top;

        if (!this.state.globalPoint) {
            this.setState({
                startPoint: point,
                globalPoint,
                scrolPosition: scrollPos
            });
        } else {
            this.setState({
                startPoint: point,
                scrolPosition: scrollPos
            });
        }
    },
    onMoveSelection(e) {
        if (!this.state.startPoint)
            return;

        var globalPoint = this.getGlobalPoint();
        var touchPoint = getTouchPosition(e);
        var point = {};
        point.x = touchPoint.x - globalPoint.left + this.getScrollPos();
        point.y = touchPoint.y - globalPoint.top;

        this.setState({
            endPoint: point
        });
    },
    onEndSelection() {
        if (this.state.startPoint && this.state.endPoint)
            timelineDragManager.getMultipleSelection(this.state.startPoint, this.state.endPoint);
        else
            timelineDragManager.resetMultipleSelection();

        this.setState({
            startPoint: undefined,
            endPoint: undefined
        });
    },
    getScrollPos() {
        if (this.state.scrolPosition)
            return this.state.scrolPosition;
        else
            return playController.getScrollPosition();
    },
    getGlobalPoint() {
        if (this.state.globalPoint)
            return this.state.globalPoint;
        else
            return this.refs.timeline.getBoundingClientRect();
    },
    getSelection() {
        if (this.state && this.state.startPoint && this.state.endPoint) {
            return {x: Math.min(this.state.startPoint.x, this.state.endPoint.x), y: Math.min(this.state.startPoint.y, this.state.endPoint.y), width: Math.abs(this.state.startPoint.x - this.state.endPoint.x), height: Math.abs(this.state.startPoint.y - this.state.endPoint.y)};

        } else {
            return undefined;
        }
    },
    render() {
        var height = audioEditorUtils.getAudioEditorHeight();
        const listHeight = audioToolUtils.isAudioTool() ? properties.SLIDE_VIEWER_TOP_GAP * 5 : properties.SLIDE_VIEWER_LIST_HEIGHT + properties.SLIDE_VIEWER_TOP_GAP;
        const normalSlideViewerHeight = properties.SLIDE_VIEWER_TOP_LINE_HEIGHT + listHeight + properties.SLIDE_VIEWER_BOTTOM_GAP;

        var menuStyle = {
            position: 'absolute',
            cursor: 'default',
            userSelect: 'none',
            WebkitUserSelect: 'none',
            top: normalSlideViewerHeight,
            left: 0,
            width: this.props.width,
            height
        };

        var timelines = [];
        var i;
        var maxTimelines = audioEditorUtils.getMaxTimelinesRelatedToHeight();

        for (i=0; i<this.props.timelines.length; i++) {
            if (i < maxTimelines)
                timelines.push(<AudioElement buttonsHolderWidth={this.props.buttonsHolderWidth} key={'timelineElement_' + i} windowWidth={this.props.windowWidth} windowHeight={this.props.windowHeight} width={this.props.width} index={i} timeline={this.props.timelines[i]} zoomValue={this.props.zoomValue} dispatch={this.props.dispatch}/>);
        }

        const selection = this.getSelection();
        var selector;

        if (selection) {
            const selectionStyle = {
                position: 'absolute',
                background: 'blue',
                top: selection.y,
                left: selection.x,
                width: selection.width,
                height: selection.height,
                borderWidth: 2,
                borderColor: 'red',
                borderStyle: 'solid',
                opacity: 0.3
            };

            selector = <div style={selectionStyle}></div>;
        }

        return (
            <div style={menuStyle} ref='timeline' id='timeline' onTouchStart={this.onStart} onTouchMove={this.onMove} onTouchEnd={this.onEnd} onMouseDown={this.onStartSelection} onMouseMove={this.onMoveSelection} onMouseUp={this.onEndSelection}>
                {timelines}
                {selector}
                <Marker zoomValue={this.props.zoomValue} dispatch={this.props.dispatch}/>
            </div>
        );
    }
});


function mapStateToProps(state) {
    const timelines = state.audioEditor.timelines;
    const currentSlideDuration = (state.currentSlide && state.currentSlide.model) ? state.currentSlide.model.time : 0;
    let windowHeight = state.production.windowHeight;

    if (!(windowHeight > 0))
        windowHeight = window.innerHeight;

    return {
        timelines,
        windowHeight,
        currentSlideDuration
    };
}

export const AudioEditorTimeline = connect(mapStateToProps)(AudioEditorTimelineContent);



/** WEBPACK FOOTER **
 ** ./src/components/audioEditor/menus/AudioEditorTimeline.js
 **/